import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon } from '@vectord/components';
import classNames from 'classnames';

import {
  DELETE_CLASS_MODAL_STAGES,
  resetSbatGroupBulkUpdate,
  setDeleteClassModalStage,
  setSelectedDeleteSbatGroup,
} from 'features/classCreation';

export default function DeleteSbatGroup({ isDisabled, sbatGroup, className }) {
  const dispatch = useDispatch();

  const handleDelete = useCallback(
    (event) => {
      event.stopPropagation();
      if (!isDisabled) {
        batch(() => {
          dispatch(setSelectedDeleteSbatGroup(sbatGroup));
          dispatch(setDeleteClassModalStage(DELETE_CLASS_MODAL_STAGES.reason));
          dispatch(resetSbatGroupBulkUpdate());
        });
      }
    },
    [dispatch, isDisabled, sbatGroup]
  );

  return (
    <Icon
      name="trash"
      className={classNames('primary m-l-xxs', className)}
      onClick={handleDelete}
    />
  );
}
